import React, { useCallback, useEffect, useMemo, useState } from 'react';
import './AdminSpecialties.scss'
import { apiSpecialties } from '../../../axios';
import { MdDelete } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import { alertForConfirmRequest } from '../../../utils/helpers';
import { useModal } from '../../../components/Modals';
import Table from '../../../components/Table';
import { adminSpecialtyPost, adminSpecialtyUpdate, adminSpecialtyDelete } from '../../../axios/admin/manageSpecialties';
import { PAGE_LIMIT_ADMIN } from '../../../data/globalConstants';

const AdminSpecialties = () => {

    const dispatchModal = useModal();
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);

    const getData = useCallback(async (paramsObj) => {
        try {
            setLoading(true);
            const result = await apiSpecialties.getSlecialties(paramsObj);
            const specialtiesCount = paramsObj?.page === 1 ? await apiSpecialties.getSpecialtiesCount(paramsObj) : count;
            setCount(specialtiesCount);
            setData(result);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }, [count]);

    const createHandler = useCallback(async (fieldsObj = {}) => {
        await adminSpecialtyPost(fieldsObj);
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search,
        });
    }, [getData, search, page]);

    const deleteHandler = useCallback(async (id) => {
        await adminSpecialtyDelete({
            id: id
        });
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search
        });
    }, [getData, search, page]);

    const updateHandler = useCallback(async (fieldsObj) => {
        await adminSpecialtyUpdate(fieldsObj);
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search
        });
    }, [getData, search, page]);

    const createOrUpdate = useCallback((obj = {}) => {
        dispatchModal('createEditSpecialties', { obj: obj, handleSuccess: (result) => obj?.id ? updateHandler(result) : createHandler(result) })
    }, [dispatchModal, createHandler, updateHandler]);

    useEffect(() => {
        getData({
            page: page,
            limit: PAGE_LIMIT_ADMIN,
            search: search
        });
    }, [getData, search, page]);

    const columns = useMemo(() => [
        {
            key: "specialty",
            children: "Спеціальність"
        },
        {
            key: "devision",
            children: "Місце надання послуг"
        },
        {
            key: "controls",
            style: {
                width: 145
            },
            children: "Керування"
        }
    ], []);

    const dataRows = useMemo(() => data.map(itm => ({
        key: itm?._id,
        className: 'admin_table_row',
        rowData: [
            {
                children: itm?.specialty
            },
            {
                children: itm?.devision?.map(itm=>itm?.nameDevision).join(', ')
            },
            {
                className: 'admin_controll_btn',
                children: <>
                    <button
                        className='admin_rewrite_btn'
                        onClick={() => createOrUpdate({
                            id: itm?._id,
                            ...itm
                        })}
                    >
                        <FaPen />
                    </button>
                    <button
                        className='admin_delete_btn'
                        onClick={() => alertForConfirmRequest(deleteHandler, itm?._id)}
                    >
                        <MdDelete />
                    </button>
                </>
            }
        ]
    })), [data, createOrUpdate, deleteHandler]);

    const emptyText = useMemo(() => {
        return search === '' ? <div className='admin_empty_table'>
            Список спеціальностей порожній
            <br />
            <button className='admin_create_element' onClick={() => createOrUpdate()}>Створити</button>
        </div> : `За пошуком "${search}" нікого не знайдено`
    }, [search, createOrUpdate]);


    return (
        <section className='admin_administration_wrapper'>
            <div className='admin_page_content'>
                <h2 className='admin_page_title'>
                    Спеціальності
                </h2>
                <div className='admin_filters_block'>
                    <input className='admin_search_input' type='text' placeholder='Пошук' onChange={e => setSearch(e.target.value)} />
                    <button className='admin_create_element' onClick={() => createOrUpdate()}>Створити</button>
                </div>

                <div className='admin_table_block'>
                    <Table
                        columns={columns}
                        data={dataRows}
                        loading={loading}
                        emptyText={emptyText}
                        pagination={{
                            count: count,
                            page: page,
                            onChange: (number) => setPage(number),
                            pageLimit: PAGE_LIMIT_ADMIN
                        }}
                    />
                </div>
            </div>
        </section>
    );
};

export default AdminSpecialties;